import { render, staticRenderFns } from "./WFCaseQueryPermissionEdit.vue?vue&type=template&id=2acb39db&scoped=true"
import script from "./WFCaseQueryPermissionEdit.vue?vue&type=script&lang=js"
export * from "./WFCaseQueryPermissionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb39db",
  null
  
)

export default component.exports